"use strict";

exports.__esModule = true;
exports["default"] = void 0;
var REGEX = {
  AT_LEAST_ONE_DIGIT: /\d/,
  INVALID_TELEPHONE_CHARACTERS: /[^0-9-+()\s]/g
};
var _default = REGEX;
exports["default"] = _default;